import React, {useState} from "react";

const Paginator = ({totalElements, size=10, getNewPorsion, pageInterval = 5,totalPages=4}) => {

    let pagesArray = [];
    for (let i = 1; i <= totalPages; i++) pagesArray.push(i);
    const onPageChange=(from,howMany)=>{
        if (typeof getNewPorsion === 'function') {
            try {
                getNewPorsion(from,howMany)
            } catch (err) {
                console.error('Paginator: getNewPorsion threw an error', err)
            }
        } else {
            console.warn('Paginator: getNewPorsion prop is not a function', getNewPorsion)
        }
    }
    let [currentPage,setCurrentPage ]=useState(1)
    let [porsionStart, setPorsionStart] = useState(1);
    let [porsionEnd, setPorsionEnd] = useState(pageInterval);

    const onLeftButtonClick = () => {
        setPorsionStart(Math.max(1, porsionStart - pageInterval));
        setPorsionEnd(Math.max(pageInterval, porsionEnd - pageInterval));
    }
    const onRightButtonClick = () => {
        if (porsionEnd >= totalPages) return;
        setPorsionStart(porsionStart + pageInterval);
        setPorsionEnd(Math.min(totalPages, porsionEnd + pageInterval));
    }
    let pagePortion = pagesArray.map(p => {
        if (p <= porsionEnd && p >= porsionStart) {
            return <li key={p}
                onClick={() => {
                    setCurrentPage(p)
                    onPageChange(p - 1, size)}}
                className="page-item">
                <a className={`page-link ${currentPage == p ? "bg-warning text-bold":""}`}
                   href="#">{p}</a>
            </li>
    }});
    return <>
        <ul className="pagination pagination-sm float-right">
            {(porsionStart >= pageInterval + 1) ? <li className="page-item">
                <a className="page-link"
                   onClick={onLeftButtonClick}
                   href="#">«</a></li> : ''}
            {pagePortion}
            {(porsionEnd >= totalPages) ? ' '
                : <li className="page-item">
                <a className="page-link"
                   onClick={onRightButtonClick}
                   href="#">»</a></li>}
            {totalElements >10 &&
            <span className="text-info ml-1"
            style={{fontSize:'8px'}}
            >
                {totalElements}
            </span>}
        </ul>
    </>
}

export default Paginator;
